




































import { Component, Prop, Vue, Provide, Watch, Emit, Ref } from 'vue-property-decorator';
import { ClassLogo, HomeIcon } from '../../assets/icons';
import ShortcutsBar from './_ShortcutsBar.vue';
import TopLevelMenuItem from './_TopLevelMenuItem.vue';
import { IMenuBar, IMenu, IMenuItemsWrapper } from '@/components/04-web-components/powerbar';
import IconButton from '../_icon-button/icon-button.vue';
import IconChip from './_IconChip.vue';
import { NavigationState } from '../../store';
import { namespace } from 'vuex-class';
const navigationState = namespace(NavigationState.name);

@Component({
    components: {
        ClassLogo,
        HomeIcon,
        IconButton,
        TopLevelMenuItem,
        ShortcutsBar,
        IconChip,
    },
})
export default class PowerbarNav extends Vue {

    @Prop({ required: true }) public username: string;
    @Prop({ required: true }) public menuBar: IMenuBar;
    @Prop({ required: false }) public eventsMenuBar: IMenuBar;
    @Prop({ required: false }) public entityChipData: any;

    @Prop({ default: '' }) public baseUrl: string;
    @Prop({ default: '' }) public homeUrl: string;

    @Prop({ default: false }) public scopeIsHome: boolean;

    @Provide() public events: IMenuItemsWrapper = { menuItems: [] };

    @navigationState.Action resetNavigation: () => void;

    @Watch('eventsMenuBar', { deep: true })
    updateEvents(val: IMenuBar) {
        this.events.menuItems = val?.menus?.[0].menuItems || [];
    }
    
    @Ref('powerbarNavContainer') powerbarNavContainer: HTMLElement;

    public get homeIconUrl(): string {
        return this.homeUrl
    }

    public get scopeIsFund(): boolean {
        return (
            !!this.menuBar?.code && this.menuBar?.code?.toLowerCase() === 'fund'
        );
    }

    public get scopeIsBusiness(): boolean {
        return (
            !!this.menuBar.code && this.menuBar.code.toLowerCase() === 'business'
            // https://app.class-test.com.au/my/business-summary?RememberTableState=False - homne?

            // https://app.class-test.com.au/b/SmartSuper/fund-administration/portfolio/list
        );
    }

    public get menus(): IMenu[] {
      return this.menuBar?.menus||[];
    }

    public onClickOutside(e: Event) {
        const navContainer = this.powerbarNavContainer;
        const eventTarget = e.target as HTMLElement;
        if (!(navContainer?.contains(eventTarget) || eventTarget?.shadowRoot?.contains(navContainer)))  {
            this.resetNavigation();
        }
    }

    public setEntityScope() {
        if(this.entityChipData){
            if(this.scopeIsFund){this.entityChipData.scope = 'fund'}
            else if(this.scopeIsBusiness){this.entityChipData.scope='business'}
        }
    }

    public setChipIsResponsive() {
        if(this.entityChipData) {
            this.entityChipData.isResponsive = this.scopeIsFund || this.scopeIsBusiness;
        }
    }

    @Emit('navigate') public navigate(e: Event) { return e; }

    public mounted() {
        this.updateEvents(this.eventsMenuBar);
        window.addEventListener('click', this.onClickOutside);
        document.querySelector('axc-powerbar')?.shadowRoot?.addEventListener('click', this.onClickOutside);
    }

    public beforeMount() {
        this.setChipIsResponsive();
    }

    public beforeUpdate() {
        this.setChipIsResponsive();
    }

    public unmounted() {
        window.addEventListener('click', this.onClickOutside);
        document.querySelector('axc-powerbar')?.shadowRoot?.addEventListener('click', this.onClickOutside);
    }

    public destroyed() { NavigationState.unregister?.(this.$store); }
    public beforeCreate() { NavigationState.register?.(this.$store); }
}
